
import { CalendarIcon, ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CardTitle } from "@/components/ui/card";
import { useTranslation } from "react-i18next";
import { formatDate } from "@/utils/dateUtils";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";

interface ScheduleHeaderProps {
  viewMode: "weekly" | "daily";
  weekDates: Date[];
  selectedDate: Date;
  onPrevious: () => void;
  onNext: () => void;
}

export function ScheduleHeader({ 
  viewMode, 
  weekDates, 
  selectedDate, 
  onPrevious, 
  onNext 
}: ScheduleHeaderProps) {
  const { t } = useTranslation("schedule");
  const isMobile = useIsMobile();
  return (
    <div className="w-full flex justify-center"> 
      
     {viewMode === "weekly" && <div className="flex items-center gap-2">
        <Button 
          variant="outline" 
          size={"icon-xs"} 
          onClick={onPrevious}
        >
          <ChevronLeft className={isMobile ? "h-3 w-3" : "h-4 w-4"} />
        </Button>
        <span className={cn("font-medium", isMobile ? "text-xs" : "text-sm")}>
            {formatDate(weekDates[0] || selectedDate, 'PP')} - {formatDate(weekDates[5] || selectedDate, 'PP')}
        </span>
        <Button 
          variant="outline" 
          size={"icon-xs"}
          onClick={onNext}
        >
          <ChevronRight className={isMobile ? "h-3 w-3" : "h-4 w-4"} />
        </Button>
      </div>}
    </div>
  );
}
